// Vue.js
import { initVue } from './vue.ts';

// TailwindCSS Styles
import "../css/tailwind.css";

// Custom font
// import "./fonts.css";

// Landing page 
import { env } from './config.ts';
import { setupDaVinci } from './davinci.ts';
import { setupNavBar } from './navbar.ts';
import { autoRowSpan } from './autorows.ts';

import ApexCharts from 'apexcharts'

declare global {
    interface Window {
        vm: any, // Vue.js instance
        observer: any
    }
}

window.ApexCharts = ApexCharts
window.autoRowSpan = autoRowSpan;
document.addEventListener('DOMContentLoaded', () => {
    if (env == "development") {
        setupDaVinci();
    }

    initVue(setupNavBar);

    autoRowSpan(".merge-rows")



});
